import React from 'react';
import { connect } from 'react-redux';
import { HCCategories, HCCategoryIds } from '_constants';
import { HelpCenterCategoryList } from './CategoryList';
import { ErrorReport } from './ErrorReport';
import styles from './HelpCenter.module.css';
import { HelpCenterRequestHelp } from './RequestHelp';
import { Locations } from './Locations';

class HelpCenter extends React.Component {


    renderContent() {
        switch (this.props.selectedCategory) {
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.REQUEST_HELP)].id:
                return (<div className={styles.content}><HelpCenterRequestHelp /></div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.HELP_DESK_TICKETS)].id:
                return (<div className={styles.content}>Coming Soon</div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.RELEASE_NOTES)].id:
                return (<div className={styles.content}>Coming Soon</div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.LIVE_CHAT)].id:
                return (<div className={styles.content}>Coming Soon</div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.TRAINING)].id:
                return (<div className={styles.content}>Coming Soon</div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.BEST_PRACTICES)].id:
                return (<div className={styles.content}>Coming Soon</div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.ONLINE_RESOURCES)].id:
                return (<div className={styles.content}>Coming Soon</div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.DEBUG_DUMP)].id:
                return (<div className={styles.content}><ErrorReport/></div>);
            case HCCategories[HCCategories.findIndex(obj => obj.id === HCCategoryIds.LOCATIONS)].id:
                return (<div className={styles.content}><Locations /></div>);
            default:
                return (<div className={styles.content}><HelpCenterRequestHelp /></div>);
        }
    }


    render() {
        return (
            <div className={styles.help_center_contents} >
                <div className={styles.content_wrapper}>
                    <div className={styles.category_list}>
                        <HelpCenterCategoryList />
                    </div>
                    <div className={styles.content}>
                        {this.renderContent()}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedCategory: state.ui.helpCenter.selectedCategory
    };
}

const connectedHelpCenter = connect(mapStateToProps)(HelpCenter);
export { connectedHelpCenter as HelpCenter }
